// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_ft-0";
export var actionModalContentContainer = "_ft-1";
export var createTagButton = "_ft-2";
export var footerContainer = "_ft-7";
export var fullWidthDivider = "_ft-3";
export var hasCreateTagButton = "_ft-4";
export var noCreateTagButton = "_ft-5";
export var tagsContainer = "_ft-6";
export var tagsModalContentContainer = "_ft-8";